<template>
    <div>
        <app-contratacao
            :contratacao="contratacao"
            v-show="mostrarContratacao"
            :contratacoesServicos="obterContratacoesServicos()"
            @obterAtualizacao="obterAtualizacao()"
        >
            <template slot="contratacaoFooter">
                <app-btn-voltar></app-btn-voltar>
            </template>
            <template slot="entregaAcoes" slot-scope="data">
                <span class="text-primary" v-if="$temAcesso('GEST-ENTR-01')">
                    <i
                        class="fa fa-info-circle fa-lg icon-button"
                        title="Detalhar"
                        @click.stop="detalharEntrega(data.entregaId)"
                    ></i>
                </span>
            </template>
        </app-contratacao>
        <router-view @obterAtualizacao="obterAtualizacao()"></router-view>
    </div>
</template>

<script>
import ContratacoesServicos from './ContratacoesServicos'
import Contratacao from '@/app/credenciados/componentes/contratacoes/Contratacao'

export default {
    data() {
        return {
            contratacao: {}
        }
    },

    methods: {
        obterContratacao() {
            this.$store.dispatch('addRequest')
            ContratacoesServicos.obterPorId(
                this.$route.params.contratacaoId
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.contratacao = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter contratação!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterAtualizacao() {
            this.obterContratacao()
            this.$store.dispatch('setRecarregar', true)
        },

        detalharEntrega(entregaId) {
            this.$router.push({
                name: 'Gestores_Entregas_Detalhar2',
                params: {
                    entregaId: entregaId
                }
            })
        },

        obterContratacoesServicos() {
            return ContratacoesServicos
        }
    },

    computed: {
        mostrarContratacao() {
            return this.$route.name == 'Gestores_Contratacoes_Detalhar'
        }
    },

    created() {
        this.obterContratacao()
    },

    components: {
        AppContratacao: Contratacao
    }
}
</script>
